import tankGradesSettingSlice from './tank-grades/tankGradesSettingSlice.js';

const productionManagerSlices = {
    tankGradesSetting: tankGradesSettingSlice
};

export default productionManagerSlices;
